/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PostTeamMember } from './PostTeamMember';

export type PutTeam = {
    business_unit: PutTeam.business_unit;
    description?: string;
    is_active: PutTeam.is_active;
    managed_by: PutTeam.managed_by;
    members?: Array<PostTeamMember>;
    name: string;
    owner_id: string;
    parent_business_unit_id?: number;
};

export namespace PutTeam {

    export enum business_unit {
        Y = 'Y',
        N = 'N',
    }

    export enum is_active {
        Y = 'Y',
        N = 'N',
    }

    export enum managed_by {
        OWNER = 'Owner',
        MEMBERS = 'Members',
    }


}
